import { type ProductBySlugResponse } from '@/modules/product/aliases';
import { getProductBreadcrumbsBrand } from '@/modules/product/helpers/getProductBreadcrumbsBrand';
import { getPathFromFilters } from '@/modules/search/helpers/getPathFromFilters';

export function getProductBreadcrumbsArgs(product?: ProductBySlugResponse) {
  const { gender, group, is_kids, product_type } = product?.attributes ?? {};
  const brand = getProductBreadcrumbsBrand(product);

  return {
    categoryPathname: getPathFromFilters({
      gender,
      groups: group || '',
      isKids: is_kids,
      productTypes: product_type ? [product_type] : [],
    }),
    linkPrefix: brand ? `/brands/${brand.slug}/c` : undefined,
  };
}
